import React, { useState, useEffect, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { Chip, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import MainCard from "components/MainCard";
import EquipmentPartChainGraphs from "./chart/EquipmentPartChainGraphs";
// import EquipmentPartSensorsGraphs from "./chart/EquipmentPartSensorsGraphs";
import EquipmentPartSensorsGraphsWithBox from "./chart/EquipmentPartSensorsGraphsWithBox";
import EquipmentPartsReplaceLayer from "../layer/EquipmentPartsReplaceLayer";
import EquipmentPartMeasurementGraphs from "./chart/EquipmentPartMeasurementGraphs";
import EquipmentPartMeasurementDurationGraphs from "./chart/EquipmentPartMeasurementDurationGraphs";

const EquipmentPartListMonitoring = ({equipment, componentId, equipmentAlertIng, equipmentParts, selectedComponent, locationCode, target="default", playMovie}) => {
    const { t, i18n } = useTranslation();

    const [equipmentPartsByComponent, setEquipmentPartsByComponent] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [selectLocationCode, setSelectLocationCode] = useState();

    const requestRefresh = useCallback(() => {
      setIsLoading(false)
    }, []);

    useEffect(() => {
        if (!selectedComponent) return;

        if (locationCode) {
            setSelectLocationCode(locationCode);
        } else {
            setSelectLocationCode(
                selectedComponent.componentLocationCode
            );
        }
        setIsLoading(true)
    }, [componentId, selectedComponent, locationCode]);

    useEffect(()=>{
        if (equipment && equipment.id && componentId && componentId > 0) {
            if (equipmentParts && equipmentParts.length > 0) {
                const equipmentPartsGroups = equipmentParts.filter(ep=>ep.group["masterEquipmentPart.equipmentCtgr.id"] == componentId)
                const sorted = [...equipmentPartsGroups].sort((a, b) => {
                    const nameA = a.group["componentLocation.name"];
                    const nameB = b.group["componentLocation.name"];

                    return nameA.localeCompare(nameB, i18n.language);
                });
                if (!locationCode)
                    setSelectLocationCode(sorted[0]?.group["componentLocation.code"])
                setEquipmentPartsByComponent(sorted);
            } else {
                setEquipmentPartsByComponent([])
            }
        }
        setIsLoading(true)
    // eslint-disable-next-line react-hooks/exhaustive-deps
    },[componentId, equipment.id, equipmentParts, isLoading]);

    function renderContent(type, htmlString, width) {
        return <TableCell align="center" style={{width:width}}>{htmlString}<EquipmentPartsReplaceLayer info={equipment} type={type} onRefresh={requestRefresh} /></TableCell>;
    }

    if (isLoading) {
    return (
        <>
        {equipmentPartsByComponent && equipmentPartsByComponent.length > 1 && equipmentPartsByComponent.map(function(data, k) {
            // console.log(data)
            return (
                <React.Fragment key={k}>
                    <p className="tab_in1" style={{cursor:"pointer", display:"inline-block", padding:"8px 15px", margin:"2px 5px 7px 0", borderRadius:"100px", border:`${selectLocationCode === data.group["componentLocation.code"] ? "3px solid #0061d0": "1px solid #0061d0"}`, backgroundColor:`#000`, color:`#fff`}} onClick={()=>{setSelectLocationCode(data.group["componentLocation.code"])}}>{data.group["componentLocation.name"]}</p>
                </React.Fragment>
            )
        })}
        {equipmentPartsByComponent && equipmentPartsByComponent.map(function(data, k) {
            // console.log(data)
            if (selectLocationCode == data.group["componentLocation.code"]) {
            return (
                <React.Fragment key={k}>
            {data.items.map((item, i)=>{
                // console.log(item)
                let componentName = item.masterEquipmentPart.name;
            return (
            <div key={i}>
                <MainCard className="center_table" content={false}>
                    <TableContainer>
                        <Table sx={{ minWidth: 500 }} aria-label="simple table" className="same_width">
                            {target === 'default' &&
                            <TableBody>
                                <TableRow>
                                    <TableCell className="th" align="center" style={{width:'90px'}}>{item.sensorYn ? t('message.common.subtitle.iot.diagnosis.equipment') : t('message.common.subtitle.material')}</TableCell>
                                    {renderContent(item.status, componentName, '120px')}
                                    <TableCell className="th" align="center" style={{width:'90px'}}>{t('message.common.subtitle.position')}</TableCell>
                                    <TableCell align="center"><Chip label={item.componentLocation?.name} color="primary" /></TableCell>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.last.inspection.date')}</TableCell>
                                    <TableCell align="center">{equipment.latestCommYmd}</TableCell>
                                </TableRow>
                                {equipmentAlertIng && item.faultCodes && item.faultCodes.length > 0 &&
                                <TableRow sx={{borderBottom: "1px solid rgba(81, 81, 81, 1)"}}>
                                    {/* <TableCell className="th" align="center">{equipmentAlertIng.fllwActionType === 'O1_WAIT' ? t('message.common.title.alarm') : t('message.common.title.reference')}</TableCell> */}
                                    <TableCell className="th" align="center">{t('message.common.title.defect')}</TableCell>
                                    <TableCell colSpan={5} style={{textAlign:'left'}}>
                                    {
                                        item.faultCodes.map(function(codes, idx) {
                                            return (
                                        <div key={idx}>
                                            {codes.subCategoryNm}({codes.categoryNm})&nbsp;
                                            {playMovie &&
                                            <span className="icon_png" style={{verticalAlign:"middle", cursor:"pointer"}}
                                                onClick={()=>{playMovie(item?.masterEquipmentPart?.code, item?.componentLocation?.code, codes.code)}}>
                                                <img src={`${process.env.PUBLIC_URL}/img/icon/emergency_recording.png`} alt='' />
                                            </span>
                                            }
                                        </div> 
                                            )
                                        })
                                    }
                                    </TableCell>
                                </TableRow>
                                }
                            </TableBody>
                            }
                            {target === 'alertView' &&
                            <TableBody>
                                <TableRow>
                                    <TableCell className="th" align="center" style={{width:'90px'}}>{item.sensorYn ? t('message.common.subtitle.iot.diagnosis.equipment') : t('message.common.subtitle.material')}</TableCell>
                                    {renderContent(item.status, componentName, '120px')}
                                    <TableCell className="th" align="center" style={{width:'90px'}}>{t('message.common.subtitle.position')}</TableCell>
                                    <TableCell align="center"><Chip label={item.componentLocation?.name} color="primary" /></TableCell>
                                </TableRow>
                                <TableRow sx={{borderBottom: "1px solid rgba(81, 81, 81, 1)"}}>
                                    <TableCell className="th" align="center">{t('message.common.subtitle.last.inspection.date')}</TableCell>
                                    <TableCell align="center" colSpan={3}>{equipment.latestCommYmd}</TableCell>
                                </TableRow>
                                {equipmentAlertIng && item.faultCodes && item.faultCodes.length > 0 &&
                                <TableRow sx={{borderBottom: "1px solid rgba(81, 81, 81, 1)"}}>
                                    {/* <TableCell className="th" align="center">{equipmentAlertIng.fllwActionType === 'O1_WAIT' ? t('message.common.title.alarm') : t('message.common.title.reference')}</TableCell> */}
                                    <TableCell className="th" align="center">{t('message.common.title.defect')}</TableCell>
                                    <TableCell colSpan={3} style={{textAlign:'left'}}>
                                    {
                                        item.faultCodes.map(function(codes, idx) {
                                            return (
                                        <div key={idx}>
                                            {codes.subCategoryNm}({codes.categoryNm})
                                        </div> 
                                            )
                                        })
                                    }
                                    </TableCell>
                                </TableRow>
                                }
                            </TableBody>
                            }
                        </Table>
                    </TableContainer>
                    {item.id && 
                        <EquipmentPartChainGraphs equipment={equipment} equipmentPartId={item.id} diagnosisResultChain={item.diagnosisResultChain} target={target} />
                    }
                    {item.sensorPositions && item.id && item.sensorPositions.length > 0 && item.sensorPositions.map(function(sPosition, j) {
                        return (
                        // <EquipmentPartSensorsGraphs key={`sensor${sPosition.id}`} equipment={equipment} equipmentPartId={item.id} equipmentPartPositionName={item.componentLocation?.name} sensorPosition={sPosition} target={target}/>
                        <EquipmentPartSensorsGraphsWithBox key={`sensor${sPosition.id}`} equipment={equipment} equipmentPartId={item.id} equipmentPartPositionName={item.componentLocation?.name} sensorPosition={sPosition} target={target}/>
                        )
                    })}
                    <EquipmentPartMeasurementGraphs key={`${item.componentLocation.id}_state`} equipmentPartId={item.id} componentLocationId={item.componentLocation?.id} />
                    <EquipmentPartMeasurementDurationGraphs key={`${item.componentLocation.id}_duration`} equipmentPartId={item.id} equipmentPartName={item.masterEquipmentPart.name} componentLocationId={item.componentLocation?.id} />
                    <div className="divide2" />
                </MainCard>
            </div>
            )
            })}
            </React.Fragment>
            )
            }
        }) 
        }
        </>
    )
    }
}

export default EquipmentPartListMonitoring;